/* tslint:disable */
/* eslint-disable */
/**
 * Gestionale.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CapannoneDTO
 */
export interface CapannoneDTO {
    /**
     * 
     * @type {number}
     * @memberof CapannoneDTO
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof CapannoneDTO
     */
    idAllevamento?: number;
    /**
     * 
     * @type {number}
     * @memberof CapannoneDTO
     */
    numero?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CapannoneDTO
     */
    superficie?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof CapannoneDTO
     */
    doppioSilos?: boolean;
}

/**
 * Check if a given object implements the CapannoneDTO interface.
 */
export function instanceOfCapannoneDTO(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CapannoneDTOFromJSON(json: any): CapannoneDTO {
    return CapannoneDTOFromJSONTyped(json, false);
}

export function CapannoneDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): CapannoneDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'idAllevamento': !exists(json, 'idAllevamento') ? undefined : json['idAllevamento'],
        'numero': !exists(json, 'numero') ? undefined : json['numero'],
        'superficie': !exists(json, 'superficie') ? undefined : json['superficie'],
        'doppioSilos': !exists(json, 'doppioSilos') ? undefined : json['doppioSilos'],
    };
}

export function CapannoneDTOToJSON(value?: CapannoneDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'idAllevamento': value.idAllevamento,
        'numero': value.numero,
        'superficie': value.superficie,
        'doppioSilos': value.doppioSilos,
    };
}

